import { Popover, Space } from 'antd'
import CIMSBadge from '../../../../CIMSBadge'
import { RecursiveCount } from '../types'

function RecursiveCounts({
  counts: badges = [],
  children,
  count = 0,
  onCountChange,
  ...rest
}: RecursiveCount) {
  if (count === 0) return null
  const badge = (
    <CIMSBadge {...rest} count={count}>
      {children}
    </CIMSBadge>
  )
  if (badges.length === 0) return badge
  return (
    <Popover
      content={
        <Space size="small" direction="vertical">
          {badges.map((badges, i) => (
            <RecursiveCounts key={i} {...badges} />
          ))}
        </Space>
      }
    >
      {badge}
    </Popover>
  )
}

export default RecursiveCounts
